import { ListOptionVariantType } from './variants';
export const getListOptionsStyles = (FOUNDATIONS, FONT) => ({
    [ListOptionVariantType.DEFAULT]: {
        titleContainer: {
            padding_left: FOUNDATIONS.spacing_300,
            padding_right: FOUNDATIONS.spacing_300,
        },
        title: {},
        optionsContainer: {
            // WARNING - When update this token, remember to update "searchListExtraHeight" in the InputSearch theme
            // For now, this calc is being updated manually. It will set automatically when new inputs are created
            padding: `${FOUNDATIONS.spacing_200} ${FOUNDATIONS.spacing_150}`,
        },
    },
    [ListOptionVariantType.INPUT_DROPDOWN]: {
        titleContainer: {
            padding_left: FOUNDATIONS.spacing_300,
            padding_right: FOUNDATIONS.spacing_300,
        },
        title: {},
        optionsContainer: {
            padding: `0 ${FOUNDATIONS.spacing_100}`,
        },
    },
});
//# sourceMappingURL=styles.js.map